import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { resetPaymentMethod, selectInvoice } from '../../../../actions/actions'
import s from './PaymentOptions.module.scss'

export default function PaymentOptions() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [activePaymentType, setActivePaymentType] = useState('invoice')
  const paymentTypes = [
    { name: 'invoice', title: t('payment.type.invoice') },
    { name: 'card', title: t('payment.type.card') }
  ]

  useEffect(() => {
    if (activePaymentType === 'invoice') dispatch(selectInvoice())
    else {
      dispatch(resetPaymentMethod())
    }
  }, [dispatch, activePaymentType])

  return (
    <>
      <h2 className={s.title}>{t('payment.invoice.title')}</h2>
      <div className={s.methods}>
        {paymentTypes.map(({ name, title }) => (
          <button
            className={classNames([s.option], { [s.active]: name === activePaymentType })}
            key={name}
            onClick={() => setActivePaymentType(name)}
          >
            {title}
          </button>
        ))}
      </div>
    </>
  )
}
